import { assignIn } from 'lodash';

/* Exit Event configuration */

// The instantiateExitEvent function will need to be called any time there is a state change on the page.
// This can be done by calling the function inside of your other JavaScript code or by adding a script tag to
// your HTML view when needed.
// i.e. <script type="text/javascript">instantiateExitEvent();</script>

export const dispatchPageLoad = (page) => {
  try {
    // instantiate a CustomEvent with an eventType of “pageLoad”
    const event = new CustomEvent('pageLoad', {
      detail: {
        /* set the value of the function’s page parameter to
         a “page” property on the CustomEvent’s detail object*/
        page: page,
      },
    });
    // dispatch the CustomEvent
    window.dispatchEvent(event);
  } catch (e) {
    // don't let analytics exception bubble up to cause problems elsewhere
  }
};

export const analyticsDataLayer = (data) => {
  if (typeof window?.metricsData?.transaction !== 'undefined') {
    assignIn(window.metricsData.transaction, data);
  } else {
    const uID = Math.random().toString(36).substr(2, 9);
    window.metricsData.transaction = {
      id: uID,
    };
    assignIn(window.metricsData.transaction, data);
  }
};
